import IosIcon from '@doist/icons/ios'
import AndroidIcon from '@doist/icons/android'
import WebIcon from '@doist/icons/web'
import BaseIcon from '@doist/icons/base'

import { Image } from '@/components/image/image'

import { parseDimension } from '@/components/HtmlArticle/utils/parse-img-size'

import css from './Icon.module.css'

export type IconProps = React.ImgHTMLAttributes<HTMLImageElement> & {
    name?: string
}

export function Icon({ name, src, width, height, alt = '', ...rest }: IconProps) {
    let InternalIcon: React.ReactNode | undefined
    if (name && name.length > 0) {
        if (name.startsWith('ios-')) {
            const normName = name.replace('ios-', '')
            InternalIcon = <IosIcon name={normName} />
        } else if (name.startsWith('android-')) {
            const normName = name.replace('android-', '')
            InternalIcon = <AndroidIcon name={normName} />
        } else if (name.startsWith('web-')) {
            const normName = name.replace('web-', '')
            InternalIcon = <WebIcon name={normName} />
        } else {
            InternalIcon = <BaseIcon name={name} />
        }
    }

    // The image is an icon we have in the bundle.
    if (InternalIcon) {
        return (
            <>
                {' '}
                <span className={css.svgArticleIcon}>{InternalIcon}</span>{' '}
            </>
        )
    }

    // The image is not an icon we have in the bundle.
    if (src) {
        // If the width and height are provided, compute the new width and height to fit
        // a maximum of 32px width.
        if (width && height) {
            const normWidth = parseDimension(width)
            const normHeight = parseDimension(height)
            const expectedWidth = 32
            if (normWidth && normHeight) {
                const computedHeight = (normHeight * expectedWidth) / normWidth

                return (
                    <span className={css.articleIcon}>
                        <Image
                            src={src}
                            priority={false}
                            alt={alt}
                            {...rest}
                            width={expectedWidth}
                            height={computedHeight}
                        />
                    </span>
                )
            }
        }

        // We do not have the width and height, fallback to regular <img>.
        return (
            <span className={css.articleIcon}>
                {/* biome-ignore lint/a11y/useAltText: will be provided */}
                <img src={src} loading="lazy" alt={alt} {...rest} />
            </span>
        )
    }

    return null
}
